"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupEnvVariables = exports.ENV_VARIABLES_ENV_NAME = void 0;

var get_environment_1 = require("./get-environment");

exports.ENV_VARIABLES_ENV_NAME = 'ENV_VARIABLES';

var getEnvVariables = function getEnvVariables() {
  if ((0, get_environment_1.getRemotionEnvironment)() === 'rendering') {
    var param = window.remotion_envVariables;

    if (!param) {
      return {};
    }

    return _objectSpread(_objectSpread({}, JSON.parse(param)), {}, {
      NODE_ENV: process.env.NODE_ENV
    });
  }

  if ((0, get_environment_1.getRemotionEnvironment)() === 'preview') {
    // Webpack will convert this to an object at compile time.
    // Don't convert this syntax to a computed property.
    return _objectSpread(_objectSpread({}, process.env.ENV_VARIABLES), {}, {
      NODE_ENV: process.env.NODE_ENV
    });
  }

  throw new Error('Can only call getEnvVariables() if environment is `rendering` or `preview`');
};

var setupEnvVariables = function setupEnvVariables() {
  var env = getEnvVariables();

  if (!window.process) {
    window.process = {};
  }

  if (!window.process.env) {
    window.process.env = {};
  }

  Object.keys(env).forEach(function (key) {
    window.process.env[key] = env[key];
  });
};

exports.setupEnvVariables = setupEnvVariables;